import React, { Component } from 'react';
import Backdrop from '../Backdrop/Backdrop';
import Button from '../Button/Button';
import classes from './Prompt.module.css';
import Spinner from '../Spinner/Spinner';
import { CSSTransition } from 'react-transition-group';

class Prompt extends Component {
    state = {
        show: true
    }



    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.show !== this.state.show || nextProps.children !== this.props.children;
    }

    okayHandler = () => {
        this.setState({ show: !this.state.show }, () => {
            this.props.promptVisibilityHandler();
        })
    }

    render() {
        let paragraphContent = this.props.forSubmission ? "Saving your work..." : "Screencaps should have at least one comment before submitting."
        let isLoading = this.props.forSubmission ? <Spinner /> : <h1>Notification</h1>
        let promptButtons = !this.props.forSubmission ?
            <div className={classes.promptButtons}>
                <Button buttonName="Okay" style={{ width: "15%", marginLeft: "1%" }} onClick={() => this.okayHandler} />
            </div> : null

        let promptComponent = (
            <CSSTransition
                in={!this.state.showScreenshotContainer}
                appear={true}
                timeout={300}
                classNames="fade"
            >
                <div>
                    <div className={classes.prompt}>
                        <div>
                            {isLoading}
                            <hr />
                            <p>{paragraphContent}</p>
                        </div>
                        {promptButtons}
                    </div>
                    <Backdrop />
                </div>
            </CSSTransition>
        )

        return (
            <div>
                {this.state.show ? promptComponent : null}
            </div>
        )
    }
}

export default Prompt